(function (window) {
  var TAG_LABEL_PREFIXES = ['productname_', 'col_', 'f_', 'cl_', 'cscl_', 'pl_', 'dsgn_'];
  var labelCache = {};
  var inFlight = {};

  function isEnglish() {
    var language = document.documentElement.lang || '';
    return language.split('-')[0].toLowerCase() === 'en';
  }

  function canFetchLabels() {
    return isEnglish() && window.crypto && window.crypto.subtle && window.TextEncoder;
  }

  function shouldFetchTag(tag) {
    return TAG_LABEL_PREFIXES.some(function (prefix) {
      return String(tag || '').indexOf(prefix) === 0;
    });
  }

  function sha256Hex(value) {
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(value))).then(function (hash) {
      return Array.prototype.map.call(new Uint8Array(hash), function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function getToken() {
    return typeof theme_accessToken !== 'undefined' ? theme_accessToken : '';
  }

  function fetchBatch(entries) {
    var token = getToken();
    if (!token || !entries.length) return Promise.resolve({});

    var query = 'query @inContext(language: EN) {' + entries.map(function (entry, index) {
      return ' t' + index + ': metaobject(handle: { type: "tags-for-translations", handle: "tag-' + entry.hash + '" }) { label: field(key: "label") { value } }';
    }).join('') + ' }';

    return fetch('/api/2024-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: query,
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (json) {
        if (!json || json.errors || !json.data) return null;
        var out = {};
        var data = json.data;
        entries.forEach(function (entry, index) {
          var node = data && data['t' + index];
          var label = node && node.label && node.label.value;
          out[entry.tag] = label || '';
        });
        return out;
      })
      .catch(function () { return null; });
  }

  window.caseplayTagLabels = {
    get: function (tags) {
      if (!canFetchLabels()) return Promise.resolve({});

      var pending = [];
      var requested = [];
      var done = {};
      (Array.isArray(tags) ? tags : [tags]).forEach(function (tag) {
        tag = String(tag || '');
        if (tag && shouldFetchTag(tag) && inFlight[tag]) {
          pending.push(inFlight[tag]);
        } else if (tag && shouldFetchTag(tag) && labelCache[tag] === undefined && requested.indexOf(tag) === -1) {
          requested.push(tag);
        }
      });

      if (!requested.length) {
        return pending.length ? Promise.all(pending).then(function () { return labelCache; }) : Promise.resolve(labelCache);
      }

      requested.forEach(function (tag) {
        inFlight[tag] = new Promise(function (resolve) {
          done[tag] = resolve;
        });
        pending.push(inFlight[tag]);
      });

      Promise.all(requested.map(function (tag) {
        return sha256Hex(tag).then(function (hash) {
          return { tag: tag, hash: hash };
        });
      })).then(function (entries) {
        var batches = [];
        for (var i = 0; i < entries.length; i += 50) {
          batches.push(fetchBatch(entries.slice(i, i + 50)));
        }

        Promise.all(batches).then(function (results) {
          results.forEach(function (result) {
            if (!result) return;
            Object.keys(result).forEach(function (tag) {
              labelCache[tag] = result[tag];
            });
          });
          entries.forEach(function (entry) {
            delete inFlight[entry.tag];
            done[entry.tag]();
          });
        });
      }).catch(function () {
        requested.forEach(function (tag) {
          delete inFlight[tag];
          done[tag]();
        });
      });

      return Promise.all(pending).then(function () { return labelCache; });
    },
    text: function (tag, fallback) {
      return labelCache[tag] || fallback || '';
    },
  };

  // Hide breadcrumb labels until their translations are ready.
  if (isEnglish()) {
    var breadcrumbStyle = document.createElement('style');
    breadcrumbStyle.textContent = '.breadcrumbs [data-taglabel], .breadcrumbs [data-product-breadcrumb] { visibility: hidden; }';
    document.head.appendChild(breadcrumbStyle);

    document.addEventListener('DOMContentLoaded', function () {
      var breadcrumbs = Array.from(document.querySelectorAll('.breadcrumbs [data-taglabel]'));
      var breadcrumbLabels = window.caseplayTagLabels.get(breadcrumbs.map(function (element) {
        return element.dataset.taglabel;
      }));
      Promise.all([breadcrumbLabels, window.caseplayTagLabels.productTitleReady]).then(function (results) {
        var labels = results[0];
        breadcrumbs.forEach(function (element) {
          var label = labels[element.dataset.taglabel];
          if (label) element.textContent = label;
        });
      }).finally(function () {
        breadcrumbStyle.remove();
      });
    });
  }

  window.caseplayDisplayTitle = function (productTitle, productNameTag) {
    // Preparation
    var normalizedTitle = String(productTitle || '');
    var normalizedTag = String(productNameTag || '');
    var japaneseTitle = normalizedTag;
    var designNameMatch = null;

    if (normalizedTag.indexOf('productname_') === 0) {
      japaneseTitle = normalizedTag.replace('productname_', '');
    }

    if (isEnglish() && normalizedTitle) {
      designNameMatch = normalizedTitle.match(/\[([^\]]+)\]|［([^］]+)］/);
    }

    // Fallback ladder
    if (designNameMatch) {
      return (designNameMatch[1] || designNameMatch[2]).trim();
    }

    if (japaneseTitle) {
      return japaneseTitle;
    }

    if (normalizedTitle) {
      return normalizedTitle;
    }

    return '';
  };
})(window);
